import { registerPlugin, type PluginListenerHandle } from '@capacitor/core';

export type ApkUpdateStart = {
  status: 'permission' | 'installing';
};

export type ApkUpdateFailure = {
  message: string;
};

interface ApkUpdatePlugin {
  downloadAndInstall(options: { url: string; prompt?: boolean }): Promise<ApkUpdateStart>;
  addListener(
    eventName: 'failed',
    listenerFunc: (event: ApkUpdateFailure) => void,
  ): Promise<PluginListenerHandle>;
}

export const ApkUpdate = registerPlugin<ApkUpdatePlugin>('ApkUpdate');
